/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-alert-message',
    templateUrl: './alert-message.component.html',
    styleUrls: ['./alert-message.component.scss'],
    standalone: false
})
export class AlertMessageComponent {

  @Input() type: 'alert' | 'warning' | 'success' = 'warning';

  @Input() message: string;
}
